module.exports = {
    SPECIAL_SCHEDULE_GET: 'SPECIAL_SCHEDULE_GET',
    SPECIAL_SCHEDULE_UPDATE: 'SPECIAL_SCHEDULE_UPDATE',
};
